import { getReservasAll } from "../services/serviceViaje";
import { newCompraItem, updateAutorizacionCompraItem } from "../services/comprasService";
const dataInicial = {
    reservas: [],
    total: 0,
    busquedaReferencia: "NA",
    busquedaEstatus: "NA",
    pagina: 0,
    registroPagina: 10,
    exito: 0,
};

const GET_RESERVAS_ALL = "GET_RESERVAS_ALL"
const GET_RESERVAS_BUSQUEDA_ALL = "GET_RESERVAS_BUSQUEDA_ALL"
const GET_RESERVAS_REGISTROS_PAGINA = "GET_RESERVAS_REGISTROS_PAGINA"
const GET_RESERVAS_PAGINA = "GET_RESERVAS_PAGINA"
const POST_RESERVAS_EXITO = "POST_RESERVAS_EXITO"
const PUT_RESERVAS_AUTORIZADO_EXITO = "PUT_RESERVAS_AUTORIZADO_EXITO"
const CLEAR_RESERVAS_STATE = "CLEAR_RESERVAS_STATE"
export default function reservasReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_RESERVAS_PAGINA:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_RESERVAS_REGISTROS_PAGINA:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_RESERVAS_BUSQUEDA_ALL:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total,
                busquedaReferencia: action.payload.busquedaReferencia,
                busquedaEstatus: action.payload.busquedaEstatus,
                pagina: action.payload.pagina,
                registroPagina: action.payload.registroPagina
            }
        case POST_RESERVAS_EXITO:
            return { ...state, exito: action.payload.exito }
        case PUT_RESERVAS_AUTORIZADO_EXITO:
            return { ...state, exito: action.payload.exito }
        case GET_RESERVAS_ALL:
            return {
                ...state,
                reservas: action.payload.reservas,
                total: action.payload.total
            };
        case CLEAR_RESERVAS_STATE:
            return {
                ...state,
                reservas: action.payload.reservas
            }
        default:
            return state;
    }
}
export const generarReservaAction = ({ idTipoCompra, idPaquete, idCuenta, idMoneda, MontoProveedor, FechaRegreso }) => async (dispatch) => {
    return await newCompraItem({ idTipoCompra, idPaquete, idCuenta, idMoneda, MontoProveedor, FechaRegreso }).then(Response => {
        dispatch({
            type: POST_RESERVAS_EXITO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const autorizarReservaAction = ({ idCompra }) => async (dispatch) => {
    return await updateAutorizacionCompraItem({ idCompra }).then(Response => {
        dispatch({
            type: PUT_RESERVAS_AUTORIZADO_EXITO,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerReservasAction = () => async (dispatch, getSate) => {
    const { busquedaReferencia, busquedaEstatus, pagina, registroPagina } = getSate().reservas
    return await getReservasAll({ Referencia: busquedaReferencia, EstatusCompra: busquedaEstatus, Pagina: pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_ALL,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasBusquedaAction = ({ Referencia, EstatusCompra }) => async (dispatch, getSate) => {
    return await getReservasAll({ Referencia, EstatusCompra, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_BUSQUEDA_ALL,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                busquedaReferencia: Referencia,
                busquedaEstatus: EstatusCompra,
                pagina: dataInicial.pagina,
                registroPagina: dataInicial.registroPagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busquedaReferencia, busquedaEstatus, pagina } = getSate().reservas
    return await getReservasAll({ Referencia: busquedaReferencia, EstatusCompra: busquedaEstatus, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_RESERVAS_REGISTROS_PAGINA,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReservasPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busquedaReferencia, busquedaEstatus, registroPagina } = getSate().reservas
    return await getReservasAll({ Referencia: busquedaReferencia, EstatusCompra: busquedaEstatus, Pagina: Pagina + 1, Registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_RESERVAS_PAGINA,
            payload: {
                reservas: Response.listViajeCompra,
                total: Response.tamanio,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_RESERVAS_STATE,
        payload: {
            dataInicial,
        },
    });
}